/**
 * Shared icon registry for status rows.
 *
 * Used by both StatusRow.tsx (card) and AircraftLabelsOverlay.tsx (map labels)
 * to resolve iconName strings to Lucide React components.
 */

import {
  AlertTriangle,
  ShieldAlert,
  FileText,
  FileWarning,
  FilePlus,
  Clock,
  Timer,
  Fuel,
  Plane,
  UserX,
  CheckCircle,
  CalendarPlus,
  CalendarClock,
  StickyNote,
  PlaneTakeoff,
} from 'lucide-react'

export const STATUS_ROW_ICON_MAP: Record<string, React.ComponentType<{ className?: string }>> = {
  AlertTriangle,
  ShieldAlert,
  FileText,
  FileWarning,
  FilePlus,
  Clock,
  Timer,
  Fuel,
  Plane,
  UserX,
  CheckCircle,
  CalendarPlus,
  CalendarClock,
  StickyNote,
  PlaneTakeoff,
}
